import React from "react";
import { Link } from "react-router-dom";
import { AREA_MAPS, listedAreaMaps } from "../Layers/areaMaps";
import { TileMap } from "./tileMaps";
import { BIG_PICTURE_PATH, LANDING_RETURN, rememberLandingScroll } from "./landingScroll";
import './BigPictureStrip.css';

// A row of the Big Picture maps under the landing page's hero, each with the same tiled map as
// its card on the Big Picture page (BigPicture.js) and opening its map as the card does. Open to
// everyone, headed by a small street sign like the logo's (components/Logo.js, .sign-label in
// Landing.css), which, with the link beside it, goes to the Big Picture page.

const MAP_PATH = '/map';

const SHORT = {propertyLad:'House prices', crimeLad:'Crime', deprivationLad:'Deprivation', rentLad:'Rents', salesRateLad:'Sales rate', connectivityLad:'Coverage', migrationLad:'Moving'};

// A mobile mast, before Coverage's short name so it reads as broadband and mobile at a glance
const TowerIcon = () => (
    <svg className="bps-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9"
         strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <circle cx="12" cy="8" r="1.7"/>
        <path d="M12 10.2 8.2 21.5M12 10.2l3.8 11.3M9.4 18h5.2"/>
        <path d="M8.6 4.6a4.9 4.9 0 0 0 0 6.8M15.4 4.6a4.9 4.9 0 0 1 0 6.8M5.8 2.2a8.6 8.6 0 0 0 0 11.6M18.2 2.2a8.6 8.6 0 0 1 0 11.6"/>
    </svg>
);

const ICON = {connectivityLad:<TowerIcon/>};

const Item = ({to, name, art, icon}) => (
    <Link className="bps-item" to={to} state={{[LANDING_RETURN]:true}} onClick={rememberLandingScroll}
          title={icon ? undefined : null}>
        <span className="bps-art">{art}</span>
        {icon ? <span className="bps-name">{icon}{name}</span> : name}
    </Link>
);

const BigPictureStrip = () => (
    <section className="wrap bps" aria-labelledby="bps-head">
        <div className="bps-head">
            <Link className="sign-label" id="bps-head" to={BIG_PICTURE_PATH}>THE BIG PICTURE <span>FREE</span></Link>
            <span className="bps-line">Or just look around. No sign-up, no postcode needed.</span>
            <Link className="bps-all" to={BIG_PICTURE_PATH}>What each map shows <span aria-hidden="true">→</span></Link>
        </div>
        <div className="bps-items">
            {listedAreaMaps.map((k) => (
                <Item key={k} to={MAP_PATH + '?s=' + k} name={SHORT[k] || AREA_MAPS[k].menuText} icon={ICON[k]}
                      art={<TileMap layer={k}/>} aria-label={ICON[k] ? AREA_MAPS[k].menuText : undefined}/>
            ))}
        </div>
    </section>
);

export default BigPictureStrip;
